import React, { forwardRef, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

interface PopOverContentProperties {
  openPopover: boolean;
  popOverContent: JSX.Element | string;
  setOpenPopover: React.Dispatch<React.SetStateAction<boolean>>;
}

const PopOverContent = forwardRef<HTMLDivElement, PopOverContentProperties>(function PopOverContent(
  { openPopover, popOverContent, setOpenPopover },
  popoverReference,
) {
  const containerReference = useRef<HTMLDivElement | null>(null);

  /**
   * Function to handle click events
   * @param {any} event mouse event
   */
  const handleClickOutside = (event: MouseEvent) => {
    // Check if click was outside the popover
    if (containerReference.current === event.target) {
      setOpenPopover(false);
    }
  };

  // Add event listener when component mounts, remove on unmount
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return openPopover
    ? ReactDOM.createPortal(
        <div className="pop-over-content-wrap" ref={containerReference}>
          <div className="pop-over-content-container" ref={popoverReference}>
            {popOverContent}
          </div>
        </div>,
        document.body,
      )
    : null;
});

export default PopOverContent;
